var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sac-checkbox-container', _vm.disable ? 'disabled' : null,],on:{"click":function($event){return _vm.handleChange(_vm.field)},"keydown":function($event){return _vm.handleChange(_vm.field)}}},[_c('div',{class:[
      'sac-checkbox',
      _vm.disable ? 'disabled' : null,
      _vm.checked ? 'active' : null,
    ],style:({
      backgroundColor: _vm.checked
        ? _vm.activeCheckboxColor
          ? _vm.activeCheckboxColor : '#2759E4' : '',
    })},[_c('span',{class:[
        'checkbox',
        _vm.checked ? 'active' : '',
      ]})]),_c('div',{class:[
      _vm.textColor === 'white' ? 'text-white' : '',
      'label',
    ]},[_vm._v(" "+_vm._s(_vm.capitalize(_vm.label))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }